import { DatePicker } from "antd";

const { RangePicker } = DatePicker;
const UiRangePicker = ({ ...restProps }) => {
    return <div>
        <label>{restProps?.label}</label>
        <RangePicker {...restProps} format={"DD-MM-YYYY"} />
    </div>
};
export default UiRangePicker